const FALLBACK_IMAGE = 'https://via.placeholder.com/800x600?text=Recipe';
const assetBaseUrl = process.env.REACT_APP_SERVER_URI ?? 'http://localhost:4000';

export const getRecipeImageUrl = (recipe) => {
  if (!recipe?.imageUrl) {
    return FALLBACK_IMAGE;
  }

  if (/^https?:\/\//i.test(recipe.imageUrl)) {
    return recipe.imageUrl;
  }

  const base = assetBaseUrl.replace(/\/$/, '');
  const path = recipe.imageUrl.startsWith('/') ? recipe.imageUrl : `/${recipe.imageUrl}`;
  return `${base}${path}`;
};

export const getRecipePlaceholder = () => FALLBACK_IMAGE;

export const getTotalTimeMinutes = (recipe) => {
  const prep = Number(recipe?.prepTime || 0);
  const cook = Number(recipe?.cookTime || 0);
  const total = prep + cook;
  return total > 0 ? total : null;
};

export const formatMinutes = (minutes, locale = 'en') => {
  if (!minutes) {
    return '—';
  }

  const minLabel = locale === 'he' ? 'דק' : 'mins';
  const hrLabel  = locale === 'he' ? 'ש' : 'h';

  if (minutes < 60) {
    return `${minutes} ${minLabel}`;
  }

  const hrs  = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return mins ? `${hrs}${hrLabel} ${mins}${minLabel}` : `${hrs}${hrLabel}`;
};

const recipeUtils = {
  getRecipeImageUrl,
  getRecipePlaceholder,
  getTotalTimeMinutes,
  formatMinutes,
};

export default recipeUtils;
